import React, { useEffect, useState } from "react";
import PermissionTable, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "./PermissionTable"; // new
import {getAuthorization} from "../../../../axios/AxiosAut";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./TableToggle.css";
import {
  setAPIDetailsPermissionTable,
  setAPIDetailsGroupPermissionTable,
} from "../../../../redux/slices/statistics/statisticSlice";

function PermissionsTableData(ID) {
  const [GroupPermissions, setGroupPermissions] = useState([]);
  const [AllPermissions, setAllPermissions] = useState([]);
  const dispatch = useDispatch();
  const APIDetailsPermissionTable = useSelector(
    (state) => state.item.APIDetailsPermissionTable
  );
  const APIDetailsGroupPermissionTable = useSelector(
    (state) => state.item.APIDetailsGroupPermissionTable
  );

  const getPermissionData = () => {
    getAuthorization()
      .get(`/company/all_permissions/`)
      .then((res) => {
        setAllPermissions(res.data.result);
        dispatch(setAPIDetailsPermissionTable(res.data.result));
      })
      .catch((err) => {
        console.log("Error in getting group permissions", err);
      });
    //Get groups permissions
    getAuthorization()
      .get(`company/group_permission/${ID.id}/`)
      .then((res) => {
        setGroupPermissions(res.data.permissions);
        dispatch(setAPIDetailsGroupPermissionTable(res.data.permissions));
      })
      .catch((err) => {
        console.log("Error in getting group permissions", err);
      });
  };
  useEffect(() => {
    //Get all permissions
    console.log("APIDetailsPermissionTable.length.......", APIDetailsPermissionTable)

    // if ( APIDetailsPermissionTable.length === 0 || APIDetailsGroupPermissionTable.length=== 0) {
      getPermissionData();
      console.log("API called.....Permission");
      // console.log("id  Supplier..", ID.id);
    // }
  }, []);

  const data = [...GroupPermissions, ...AllPermissions];
  const filteredData = [];
  data.reduce((acc, curr) => {
    if (acc.indexOf(curr.codename) === -1) {
      acc.push(curr.codename);
      filteredData.push(curr);
    }
    return acc;
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Permission Name",
        accessor: "name",
      },
      {
        Header: "Description",
        accessor: "descriptions",
        // Cell: StatusPill,
      },
    ],
    []
  );
  return (
    <>
      <div className="">
        <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
          <div className="mt-1">
            <PermissionTable
              columns={columns}
              data={filteredData}
              AllowedPermissions={GroupPermissions}
              ID={ID}
            />
          </div>
        </main>
      </div>
    </>
  );
}

export default PermissionsTableData;
